export enum AvailableLanguage
{
    ITALIAN         = "it",
    ENGLISH         = "it",
    DEFAULT         = "it"
}